import { useEffect } from 'react';
import { useEmmaJS } from './useEmmaJS';
import { isEmmaApp, isInsideChatbot } from '../helpers/common';

type Options = {
  showTopBar?: boolean;
  title?: string;
  showBackBtn?: boolean;
  showCloseBtn?: boolean;
  /**
   * if directly used in hk-emma-web, emmajs will keep request timeout in web portal,
   * add this flag to bypass the request in web portal when using this hook in hk-emma-web,
   */
  isEmmaWeb?: boolean;
};

export const useMobileTopBar = (options?: Options) => {
  const emmaJS = useEmmaJS();

  useEffect(() => {
    if (options.isEmmaWeb && !isEmmaApp) return;

    if (emmaJS) {
      if (options?.title !== undefined) {
        emmaJS.instance.setNavigationTitle(options.title);
      }
      if (options.showBackBtn !== undefined && !isInsideChatbot()) {
        if (options.showBackBtn) {
          emmaJS.instance.showBackButton();
        } else {
          emmaJS.instance.hideBackButton();
        }
      }
      if (options.showCloseBtn !== undefined && !isInsideChatbot()) {
        if (options.showCloseBtn) {
          emmaJS.instance.showCloseButton();
        } else {
          emmaJS.instance.hideCloseButton();
        }
      }
      if (options.showTopBar !== undefined && !isInsideChatbot()) {
        if (options.showTopBar) {
          emmaJS.instance.showTopbar();
        } else {
          emmaJS.instance.hideTopbar();
        }
      }
    }
  }, [emmaJS, options]);
};

export default useMobileTopBar;
